import React, { useState } from "react";
import "../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/QuestionFixed.css";
import QuestionBody from "../../../components/question-components/QuestionBody";

const QuestionFixed = () => {
  const [questionCount] = useState(211);
  const [selectedQuestions, setSelectedQuestions] = useState(20);

  return (
    <div className="fixed-sets-container">
      <div className="header-section">
        <div className="header-text">
          <h1>Fixed sets and timed tests</h1>
          <p>
            Fixed sets allow you to attempt a defined number of questions. These
            can also be attempted as a timed test if required. These can be
            saved and completed at a later date.
          </p>
        </div>

        <div className="header-controls">
          <div className="question-controls">
            <div className="question-count">
              {questionCount} questions found
            </div>

            <select
              className="question-select"
              value={selectedQuestions}
              onChange={(e) => setSelectedQuestions(Number(e.target.value))}
            >
              <option value={20}>20 questions</option>
              <option value={40}>40 questions</option>
              <option value={60}>60 questions</option>
            </select>

            <button className="start-button">Start the fixed set</button>
          </div>
        </div>
      </div>

      <div>
        <QuestionBody />
      </div>
    </div>
  );
};

export default QuestionFixed;
